import { render } from "./MobileKaiJsp.vue?vue&type=template&id=20727756&scoped=true"
import script from "./MobileKaiJsp.vue?vue&type=script&lang=js"
export * from "./MobileKaiJsp.vue?vue&type=script&lang=js"

import "./MobileKaiJsp.vue?vue&type=style&index=0&id=20727756&scoped=true&lang=less"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_9acfb15ce118456a03f39fb117bb0076/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20727756"]])

export default __exports__